import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "panel"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_tree = _resolveComponent("el-tree");
    const _component_el_aside = _resolveComponent("el-aside");
    const _component_el_main = _resolveComponent("el-main");
    const _component_el_container = _resolveComponent("el-container");
    const _component_el_button = _resolveComponent("el-button");
    const _component_el_dialog = _resolveComponent("el-dialog");
    return _openBlock(), _createBlock(_component_el_dialog, {
        title: "选择商品",
        modelValue: $data.visible,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.visible = $event),
        "align-center": "",
        width: 1000,
        "destroy-on-close": "",
        onClosed: _cache[4] || (_cache[4] = ($event)=>_ctx.$emit('closed'))
    }, {
        footer: _withCtx(()=>[
                _createVNode(_component_el_button, {
                    onClick: _cache[1] || (_cache[1] = ($event)=>$data.visible = false)
                }, {
                    default: _withCtx(()=>[
                            ..._cache[5] || (_cache[5] = [
                                _createTextVNode("取 消", -1)
                            ])
                        ]),
                    _: 1
                }),
                _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit('submit'))
                }, {
                    default: _withCtx(()=>[
                            ..._cache[6] || (_cache[6] = [
                                _createTextVNode("保 存", -1)
                            ])
                        ]),
                    _: 1
                })
            ]),
        default: _withCtx(()=>[
                _createVNode(_component_el_container, null, {
                    default: _withCtx(()=>[
                            _createVNode(_component_el_aside, {
                                width: "171px",
                                style: {
                                    "height": "470px"
                                }
                            }, {
                                default: _withCtx(()=>[
                                        _createVNode(_component_el_tree, {
                                            data: $data.data,
                                            props: $data.defaultProps,
                                            onNodeClick: $options.handleNodeClick
                                        }, {
                                            default: _withCtx(({ node, data })=>[
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass({
                                                            empty: true,
                                                            checked: data?.components === $data.selectComponents
                                                        })
                                                    }, [
                                                        _createElementVNode("span", null, _toDisplayString(node.label), 1)
                                                    ], 2)
                                                ]),
                                            _: 1
                                        }, 8, [
                                            "data",
                                            "props",
                                            "onNodeClick"
                                        ])
                                    ]),
                                _: 1
                            }),
                            _createVNode(_component_el_main, null, {
                                default: _withCtx(()=>[
                                        $data.selectComponents ? (_openBlock(), _createBlock(_resolveDynamicComponent($data.selectComponents), {
                                            key: 0,
                                            modelValue: $data.url,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.url = $event)
                                        }, null, 8, [
                                            "modelValue"
                                        ])) : (_openBlock(), _createElementBlock("div", _hoisted_1, " 请在左侧选择路径分类 "))
                                    ]),
                                _: 1
                            })
                        ]),
                    _: 1
                })
            ]),
        _: 1
    }, 8, [
        "modelValue"
    ]);
}
